/* istanbul ignore file */
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LTI1p3ProviderDataParser = /* #__PURE__ */ parsers.object([
    ['tenantId', codecString, 'tenant_id'],
    ['label', /* #__PURE__ */ codecOptional(codecString)],
    ['iss', codecString],
    [
        'lms',
        /* #__PURE__ */ parsers.exactly('Canvas', 'Blackboard', 'Moodle', 'Brightspace', 'Revel', 'XL', 'Bronte'),
    ],
    ['ltiVersion', /* #__PURE__ */ parsers.exactly('lti1.3'), 'lti_version'],
]);
export class LTI1p3ProviderData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LTI1p3ProviderDataParser.decode(input).map(res => new LTI1p3ProviderData(res));
    }
    static unsafeDecode(input) {
        return LTI1p3ProviderData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LTI1p3ProviderDataParser.encode(data);
    }
    static schema() {
        return LTI1p3ProviderDataParser.schema();
    }
}
